import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { appInsights } from './services/AppInsightsService';
import './App.css';
import { CssBaseline, Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import {
  Route,
  Routes
} from "react-router-dom";
import Events from './components/events/Events';
import Circuits from './components/circuits/Circuits';
// import OntimeAppBar from './components/OntimeAppBar';
import MainAppBar from './components/common/MainAppBar';
// import AuthService from './services/Auth/AuthService';
import { AuthProvider } from './services/Auth/AuthContext';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './services/AppInsightsService';
import EventDetail from './components/events/EventDetail';
import ParticipantDetail from './components/participants/ParticipantDetail';
import CircuitDetail from './components/circuits/CircuitDetail';
import CircuitEventsPage from './components/circuits/CircuitEventsPage';
import CircuitBikesHallOfFamePage from './components/circuits/CircuitBikesHallOfFamePage';
import CircuitCarsHallOfFamePage from './components/circuits/CircuitCarsHallOfFamePage';
import OrganizerDetail from './components/organizers/OrganizerDetail';
// import GuardedRoute from './components/common/GuardedRoute';
import config from './config';
import Unauthorized from './components/common/Unauthorized';
import EventSetup from './components/events/setup/EventSetup';
// import { AuthServiceInstance } from './services/Auth/AuthService';
import Organizers from './components/organizers/Organizers';
import { AuthService } from './services/Auth/AuthService';
import OrganizerEvents from './components/events/setup/OrganizerEvents';
import { SnackbarProvider } from 'notistack';
import UserHistory from './components/user/UserHistory';
import TagManagement from './components/user/TagManagement';
import RegisterTag from './components/user/RegisterTag';
import CircuitsSetup from './components/circuits/setup/CircuitsSetup';
import ReadersSetup from './components/admin/readers/ReadersSetup';
import ParticipantDummy from './components/participants/ParticipantDummy';
import AdminTagManagement from './components/admin/tags/AdminTagManagement';
import ReadersMonitor from './components/admin/monitor/ReadersMonitor';
import AdminUserManagement from './components/admin/users/AdminUserManagement';
import PoisonQueues from './components/admin/poison/PoisonQueues';
import Profile from './components/user/Profile';
import AccessCode from './components/common/AccessCode';
import SigninCallback from './components/account/SigninCallback';
import SignoutCallback from './components/account/SignoutCallback';
import RiderReadsPage from './components/events/RiderReadsPage';
import HelpPage from './components/help/HelpPage';
// import Login from './components/account/Login';
// import Register from './components/account/Register';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    }
  }),
);

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    appInsights.trackPageView({
      name: location.pathname,
      uri: window.location.origin + location.pathname + location.search + location.hash,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

function App() {
  const classes = useStyles();
  // const authService = useContext(AuthContext);
  const [loaded, setLoaded] = useState(false);
  const [authService, setAuthService] = useState<AuthService>();
  useEffect(() => {
    if (!loaded) {
      AuthService.theInstance().then(asvc => {
        setAuthService(asvc);
        setLoaded(true);
      });

    }
  },[loaded]);

  return (

    <AppInsightsContext.Provider value={reactPlugin}>
    <SnackbarProvider>
      <AuthProvider value={authService}>
        <div className={classes.root}>
          <CssBaseline />
          <PageViewTracker />
          <MainAppBar />
          <Routes>
            <Route path="/circuits" element={<Circuits />} />
            <Route path="/circuits/:circuitId" element={<CircuitDetail />} />
            <Route path="/circuits/:circuitId/events" element={<CircuitEventsPage />} />
            <Route path="/circuits/:circuitId/hall-of-fame/bikes" element={<CircuitBikesHallOfFamePage />} />
            <Route path="/circuits/:circuitId/hall-of-fame/cars" element={<CircuitCarsHallOfFamePage />} />
            <Route path="/event/setup/:eventId" element={<EventSetup />} />
            <Route path="/event/:eventId" element={<EventDetail />} />
            <Route path="/rider/:eventId/:tagId" element={<ParticipantDetail />} />
            <Route path="/rider/:eventId" element={<ParticipantDetail />} />
            <Route path="/dummy" element={<ParticipantDummy />} />
            <Route path="/events/organizer" element={<OrganizerEvents />} />
            <Route path="/events" element={<Events />} />
            <Route path="/organizers" element={<Organizers />} />
            <Route path="/organizers/:organizerId" element={<OrganizerDetail />} />
            {/* <Route path="/account/login" element={<Login />} />
            <Route path="/account/register" element={<Register />} /> */}
            <Route path="/signin-callback" element={<SigninCallback />} />
            <Route path="/signout-callback" element={<SignoutCallback />} />
            <Route path="/user/profile" element={<Profile />} />
            <Route path="/user/history" element={<UserHistory />} />
            <Route path="/user/tags" element={<TagManagement />} />
            <Route path="/user/registerTag" element={<RegisterTag />} />

            {/* <GuardedRoute path="/organizers" component={AdminCircuit} auth={this.isOrganizer()} /> */}

            {/* <Route path="/organizers" component={authService?.isInRole(config.managementGroups.organizer) ? AdminCircuit : Unauthorized} /> */}
            <Route path="/admin/circuits" element={authService?.isInRole(config.managementGroups.administrator) ? <CircuitsSetup /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/admin/readers" element={authService?.isInRole(config.managementGroups.administrator) ? <ReadersSetup /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/admin/tags" element={authService?.isInRole(config.managementGroups.administrator) ? <AdminTagManagement /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/admin/monitoring" element={authService?.isInRole(config.managementGroups.administrator) ? <ReadersMonitor /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/admin/users" element={authService?.isInRole(config.managementGroups.administrator) ? <AdminUserManagement /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/admin/poison-queues" element={authService?.isInRole(config.managementGroups.administrator) ? <PoisonQueues /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/admin/rider/:raceId/:tagId/reads" element={authService?.isInRole(config.managementGroups.administrator) ? <RiderReadsPage /> : <Unauthorized />} errorElement={<Unauthorized />} />
            <Route path="/access-code" element={<AccessCode />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/" element={<Events />} />
          </Routes>

        </div>
      </AuthProvider>
    </SnackbarProvider>
    </AppInsightsContext.Provider>

  );
}



export default App;
